import { Font, StyleSheet } from '@react-pdf/renderer';
Font.register({
  family: 'Lato',
  fonts: [
    { src: '/Lato-Thin.ttf', fontWeight: 100 },
    { src: '/Lato-Light.ttf', fontWeight: 300 },
    { src: '/Lato-Regular.ttf', fontWeight: 400 },
    { src: '/Lato-Bold.ttf', fontWeight: 700 },
    { src: '/Lato-Black.ttf', fontWeight: 900 },
    { src: '/Lato-ThinItalic.ttf', fontWeight: 100, fontStyle: 'italic' },
    {
      src: '/Lato-LightItalic.ttf',
      fontWeight: 300,
      fontStyle: 'italic',
    },
    {
      src: '/Lato-RegularItalic.ttf',
      fontWeight: 400,
      fontStyle: 'italic',
    },
    { src: '/Lato-BoldItalic.ttf', fontWeight: 700, fontStyle: 'italic' },
    {
      src: '/Lato-BlackItalic.ttf',
      fontWeight: 900,
      fontStyle: 'italic',
    },
  ],
});

Font.register({
  family: 'FontAwesome',
  src: 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/webfonts/fa-solid-900.ttf',
});

export const styles = StyleSheet.create({
  icon: {
    fontFamily: 'FontAwesome',
    fontSize: 12,
  },
  whiteIcon: {
    backgroundColor: 'black',
    borderRadius: '50%',
    color: 'white',
    fontFamily: 'FontAwesome',
    fontSize: 10,
    transform: 'scale(1.1)',
    padding: '13 10',
  },

  targetGroupsWrapper: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 5,
    justifyContent: 'flex-start',

    marginLeft: 53,
    marginRight: 53,
  },
  targetGroupsItem: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    width: 118,
  },
  targetGroupsHeader: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: 4,
  },

  columnTitle: {
    fontWeight: 700,
    fontSize: 14,
    fontFamily: 'Lato',
  },
  boldText: {
    fontWeight: 900,
    fontSize: 16,
    fontFamily: 'Lato',
  },
  titleText: {
    fontWeight: 700,
    fontSize: 24,
    fontFamily: 'Lato',
    marginLeft: 53,
    marginRight: 53,
  },
  regularText: {
    fontWeight: 300,
    fontSize: 13,
    fontFamily: 'Lato',
  },
  smallText: {
    fontWeight: 400,
    fontSize: 9,
    fontFamily: 'Lato',
  },

  progressBarContainer: {
    width: '100%',
    height: 10,
    backgroundColor: '#eee',
    borderRadius: 3,
    marginTop: 2,
    padding: 2,
  },
  progressBarFill: {
    height: '100%',
    borderRadius: 3,
  },
  rowSpaceBetween: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
});
